/** Session key for GET `/tasks` JSON payload, scoped by student identity. */
export function getTasksSnapshotStorageKey(identityId: string): string {
  return `onboarding.tasks.snapshot.${identityId}`;
}

let tasksSnapshotSessionWriteSeq = 0;

export function getTasksSnapshotSessionWriteSeq(): number {
  return tasksSnapshotSessionWriteSeq;
}

export function writeTasksSnapshotFromJson(identityId: string, payload: unknown): void {
  try {
    sessionStorage.setItem(getTasksSnapshotStorageKey(identityId), JSON.stringify(payload));
    tasksSnapshotSessionWriteSeq += 1;
  } catch {
    // Quota or private mode — ignore
  }
}

export function readTasksSnapshotJson(identityId: string): unknown | null {
  try {
    const raw = sessionStorage.getItem(getTasksSnapshotStorageKey(identityId));
    if (raw == null || raw === '') return null;
    return JSON.parse(raw) as unknown;
  } catch {
    return null;
  }
}
